import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    title: 'The 4-Hour Reset Full Digital Manual',
    desc: 'Step-by-step "Bridge" protocol'
  }, {
    title: 'The 15-Minute Reset Cheat Sheet',
    desc: 'Minute-by-minute countdown'
  }, {
    title: 'The Cortisol Loop Troubleshooting Guide',
    desc: "For when things don't go as planned"
  }, {
    title: 'The 4-Hour Reset Daily Tracker & Anxiety Audit',
    desc: 'Track progress and maternal wellbeing'
  }];
  return <section className="bg-softWhite py-20 px-6" data-id="element-102">
      <div className="max-w-4xl mx-auto" data-id="element-103">
        <h2 className="text-3xl md:text-4xl font-serif text-center mb-12" data-id="element-104">
          Here's Exactly What You Get
        </h2>

        <div className="grid gap-6" data-id="element-105">
          {deliverables.map((item, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-sage/10 flex items-start gap-4 hover:border-sage/30 transition-colors" data-id="element-106">
              <CheckCircle2 className="w-6 h-6 text-sage shrink-0 mt-1" data-id="element-107" />
              <div data-id="element-108">
                <h4 className="text-xl font-serif font-semibold text-charcoal" data-id="element-109">
                  {item.title}
                </h4>
                <p className="text-charcoal/70 font-sans mt-1" data-id="element-110">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}